import { render } from "./HeaderMenuItem.vue?vue&type=template&id=79a18063&ts=true"
import script from "./HeaderMenuItem.vue?vue&type=script&lang=ts"
export * from "./HeaderMenuItem.vue?vue&type=script&lang=ts"

import "./HeaderMenuItem.vue?vue&type=style&index=0&id=79a18063&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__